import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sitemap-missing-urls',
  templateUrl: './sitemap-missing-urls.component.html',
  styleUrls: ['./sitemap-missing-urls.component.css']
})
export class SitemapMissingUrlsComponent {
  @Input() urls: any[] = [];
}
